import * as React from 'react';
import { SVGProps } from 'react';

const IconFileDiskSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 8a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0ZM8 11.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM8.5 8a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0ZM14 8A6 6 0 1 0 2 8a6 6 0 0 0 12 0Zm1 0A7 7 0 1 0 1 8a7 7 0 0 0 14 0Z"
    />
  </svg>
);
export default IconFileDiskSizeS;
